import ActionTypes from '../../../../../../ActionsTypes';
export function toggleCheckbox(countryID, plotID, input) {
  return {
    type: ActionTypes.TOGGLE_CHECKBOX,
    payload: {
      countryID: countryID,
      plotID: plotID,
      input: input
    }
  };
}
export function unCheckBox(countryID, plotID, key) {
  return {
    type: ActionTypes.UNCHECK_CHECKBOX,
    payload: {
      countryID: countryID,
      plotID: plotID,
      key: key
    }
  };
}